import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenue } from "src/app/shared/models/oo-venue";

@Component({
	selector: "app-unsubscribe",
	templateUrl: "./unsubscribe.component.html",
	styleUrls: ["../customer-marketing.style.scss"],
})
export class UnsubscribeComponent implements OnInit {
	blastKey: string;
	customerKey: string;
	customerEmail: string;
	templateKey: string;
	ooVenue: OOVenue;
	venueKey: number;

	unsubscribed: boolean = false;

	constructor(public app: AppService, private focuslink: FocuslinkService, private route: ActivatedRoute) {}

	ngOnInit(): void {
		this.venueKey = +this.route.snapshot.paramMap.get("venueKey");
		this.customerKey = this.route.snapshot.queryParamMap.get("cid");
		this.customerEmail = this.route.snapshot.queryParamMap.get("eid");
		this.blastKey = this.route.snapshot.queryParamMap.get("bid");
		this.templateKey = this.route.snapshot.queryParamMap.get("tid");

		this.init();
	}

	async init() {
		this.getVenue();
	}

	async getVenue() {
		const resp = await this.focuslink.getOOVenue(this.venueKey);
		this.ooVenue = new OOVenue(resp);
	}
	async confirmUnsubscribe() {
		this.focuslink.marketingBlastUnsubscribe(this.venueKey, this.customerKey, this.blastKey, this.templateKey);
		this.unsubscribed = true;
	}
}
